import { useCallback, useEffect, useState, memo } from "react";
import { useTranslate } from "@/hooks/use-translate/useTranslate";
import InputText from "@/components/input-text/InputText";
import PrimaryButton from "@/components/buttons/primary-button/PrimaryButton";
import SecondaryButton from "@/components/buttons/secondary-button/SecondaryButton";

interface SnStandQueryProps {
  closeCreator: () => void;
  changeSnStand: (snData: string) => void;
  searchInspection: () => void;
  snStand: string;
}

const SnStandQuery = ({
  closeCreator,
  changeSnStand,
  searchInspection,
  snStand,
}: SnStandQueryProps) => {
  const translate = useTranslate();

  const [requiredField, setRequiredField] = useState(false);

  const searchBySnStand = useCallback(() => {
    if (!snStand) {
      setRequiredField(true);
    } else {
      setRequiredField(false);
      searchInspection();
    }
  }, [snStand, searchInspection]);

  useEffect(() => {
    return () => {
      setRequiredField(false);
    };
  }, []);

  return (
    <div className="w-[520px] max-w-[calc(100vw-48px)]">
      <InputText
        value={snStand}
        onChange={changeSnStand}
        size="medium"
        label={translate("snStand")}
        placeholder={translate("snStand")}
        required={requiredField}
        requiredAsterisk
      />
      <div className=" w-full">
        <PrimaryButton
          colour="red"
          icon="check"
          label={translate("validate")}
          onClick={searchBySnStand}
        />
      </div>
      <div className="mt-4 w-full">
        <SecondaryButton
          colour="red"
          label={translate("cancel")}
          onClick={closeCreator}
        />
      </div>
    </div>
  );
};

export default memo(SnStandQuery);
